import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useServicesUpdate = () => {
    const [loading, setLoading] = useState(false);
    const updateServiceCharges = async (data) => {
        // Update service charges
        setLoading(true);
        try {
            const result = await apiService.updateServiceCharges(data);
            setLoading(false);
            return result;
        } catch (error) {
            setLoading(false);
        }
    }

    return {
        loading,
        updateServiceCharges,
    }
}